import React from 'react';

import { View, Pressable, StyleSheet } from 'react-native';
import { COLOR } from '../constants/styles';
import { OPPureComponent } from './components';

const BACKGROUND_STYLE_OPEN = { opacity: 1 };

export default class ModalConfirm extends OPPureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmationOpts: null,
      backgroundStyle: {},
    };
  }
  componentDidMount() {
    window?.addEventListener?.('resize', this.checkWebWidth);
  }
  componentWillUnmount() {
    window?.removeEventListener?.('resize', this.checkWebWidth);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.appCompId !== prevProps.appCompId) {
      this.setState({ confirmationOpts: null });
      return;
    }
    if (this.state.confirmationOpts && !prevState.confirmationOpts) {
      setTimeout(() => {
        this.setState({ backgroundStyle: BACKGROUND_STYLE_OPEN });
      });
      return;
    }
  }

  checkWebWidth = () => {
    this.forceUpdate();
  };
  showConfirm = (confirmationOpts) => {
    this.setState({
      confirmationOpts,
    });
  };

  render() {
    const confirmationOpts = this.state.confirmationOpts;
    if (!confirmationOpts) {
      return null;
    }

    let backgroundStyle = {
      ...this.state.backgroundStyle,
    };

    return (
      <Pressable style={styles.backgroundTappable} onPress={confirmationOpts?.onCancelled}>
        <View style={[styles.modalBackground, backgroundStyle]}>
          <View style={[styles.container]}>{confirmationOpts.renderedContents}</View>
        </View>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  backgroundTappable: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 200,
  },
  modalBackground: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: COLOR.overlay,
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0,
    transition: 'opacity 250ms ease-out',
  },
  container: {
    backgroundColor: COLOR.accent,
    borderWidth: 1,
    borderColor: COLOR.accent,
    borderRadius: 5,
    overflow: 'hidden',
  },
});
